<template>
  <el-container class="flights-wrapper">
    <el-main class="flights-container">
      <LadSearchFlights class="flights-search" @loading="handleLoading" />

      <el-card shadow="never">
        <p>{{ $t(`${base}.description.p1`, { name: header.name }) }}</p>
        <p>{{ $t(`${base}.description.p2`, { name: header.name }) }}</p>
        <p>{{ $t(`${base}.description.p3`, { name: header.name }) }}</p>
        <p>{{ $t(`${base}.description.p4`) }}</p>
      </el-card>

      <LadFlightsList v-if="items.length" class="flights-list" />
    </el-main>
  </el-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import LadSearchFlights from '@/components/pages/kiwi/components/search'
import LadFlightsList from '@/components/pages/kiwi/components/flights-list'

export default {
  name: 'LadSearchFlightsTab',
  components: {
    LadSearchFlights,
    LadFlightsList,
  },
  data() {
    return {
      base: 'flights.tab',
      loading: false,
    }
  },
  computed: {
    ...mapState('search', {
      header: 'header',
    }),
    ...mapState('kiwi', {
      items: (state) => state.items,
    }),
    ...mapState('settings', {
      country: (state) => state.locale.split('_')[1],
      currency: 'currency',
    }),
    ...mapGetters('settings', ['language']),
    ...mapGetters('device', ['isMobile']),
    cover() {
      return {
        src: `${process.env.DO_SPACES_CDN_ENDPOINT}/web-client/covers/torres-del-paine.jpg`,
        srcset: `${process.env.DO_SPACES_CDN_ENDPOINT}/web-client/covers/torres-del-paine.jpg 1x`,
        title: this.$t(`${this.base}.meta.title`),
        imgMinHeight: 600,
        imgMaxWidth: this.isMobile ? 900 : 1920,
      }
    },
  },
  methods: {
    handleLoading(boolean) {
      this.loading = boolean
    },
  },
}
</script>

<style lang="scss">
.flights-wrapper {
  background-color: #ebeef2;

  .flights-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px;
    grid-auto-rows: auto;
  }

  .flights-search {
    grid-column: 1;
  }

  .flights-main {
    grid-column: 1;

    .flights-suggest {
      display: grid;
      grid-template-columns: repeat(3 1fr);
      grid-gap: 10px;
      grid-auto-rows: auto;
    }
  }
}
</style>
